"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mvu_1 = __importDefault(require("./mvu"));
exports.useMVU = mvu_1.default;
exports.default = mvu_1.default;
//# sourceMappingURL=index.js.map